// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1LhDV","disabled":"FileBtn_disabled__duu07","warn":"FileBtn_warn__24Gdr","fade":"FileBtn_fade__11_n1"};